import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '../../../../tool'

import { templateConfig, reduxTemplateConfig } from './config'

let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool
let { WizBrowserExport } = component_tool
const { Session } = utils_tool

class Follow extends WizContainer {

  componentName = 'follow'

  constructor(props) {
    super(props)
    const { history } = props
    let topic = {}
    if (history.location) {
      if (history.location.pathname === '/community/topic/follow') {
        if (history.location && history.location.record) {
          topic = history.location.record
          Session.set('topic_follow', topic)
        } else {
          topic = Session.get('topic_follow') || {}
        }
      }
    }
    this.state = {
      topic
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true
    } else {
      wizNotice.error(o['msg'])
      return false
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户昵称',
        field: 'nickName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户属性',
        field: 'userType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关注时间',
        field: 'topicFollowTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['userType'] == 0 ? e['userType'] = '学员' : e['userType'] == 1 ? e['userType'] = 'SGM总部' : e['userType'] == 2 ? 'SGM区域' : e['userType'] = '供应商'
        e['disabled'] == 0 ? e['state'] = '禁用' : e['state'] = '启用'
      })
      WizBrowserExport({
        title: '关注信息',
        sheetName: '关注信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '关注信息.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false
    }
  }

  _render() {
    let defaultParams = {}
    let { topic } = this.state
    if (topic && topic.id) {
      defaultParams.topicId = topic.id
    }

    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({ defaultParams }),
      apiDataFormat: {
        export: this._handleFile,
      },
      defaultParams
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(Follow)

